import { filter, get, join, map, size, toUpper } from 'lodash'

const countProps = [
  'misspellingsCount',
  'translationsCount',
  'lemmatizationsCount',
]

const getIngredientKeywordCountText = node => {
  if (node.isSubtype) {
    return `${size(node.children) || ''}`
  }

  const countPropsBiggerThanZero = filter(
    countProps,
    countProp => get(node, countProp) > 0,
  )

  return join(
    map(countPropsBiggerThanZero, countProp => {
      const capitalizedFirstLetter = toUpper(countProp[0])
      return `${capitalizedFirstLetter}${get(node, countProp)}`
    }),
    '/',
  )
}

export default getIngredientKeywordCountText
